export default __webpack_public_path__ + "static/media/our-team-mobile-hero.42ce6bb7.png";